export enum EventTypeEnum {
    FacebookEvent = 'FacebookEvent',
    Event = 'Event',
    NewEvent = 'NewEvent',
}